/**
 * Created by fers on 23.05.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {MiniPanel} from './EmbededPanel.react';
import {isPanelInjected} from '../loadingLine/renderLoadingPanel.react';
import {sendMessage} from './EmbededPanelController';
import urlMapping from '../app/URLMapping';
import {FormattedMessage, IntlShape} from 'react-intl';
import config from '../../common/config';
import EventTracker from '../app/EventTracker';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {createChannelFromChannelDef} from '../channels/ChannelAddStep1.react';
import LoadingButton from '../fw/LoadingButton.react';
import {displayError} from '../app/errorDisplayer';
import {openDialog, isOutlookPanel} from '../../outlook/dialog';
import {allowedMiniPanel} from '../embedPanel';
import { User } from '../../common/types/types';

interface NoChannelPanelProps {
 user: User;
}

class NoChannelPanel extends React.Component<NoChannelPanelProps> {

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
    };

    static propTypes = {
        user: PropTypes.object.isRequired,
    };

    config = () => {
        let organisation = this.props.user.organisations.edges[0].node;

        return createChannelFromChannelDef(this.props.user.channelDef, organisation, true).then((channel) => {
            let args = {
                ...this.context.embededPanelController.getURLObject(),
                channel_id: channel['realId'],
                organisation_id: organisation['realId']
            };

            let path = urlMapping.getUrl("panel", "create-screen-step-2", args);
            if (isOutlookPanel()) {
                openDialog(path);
            }
            else if (isPanelInjected()) {
                sendMessage({msg: 'dativeryScreenSettings', url: path});
            }
            else {
                this.context.router.push(path);
            }
        }).catch((e) => {
            displayError(e);
        });
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }

    render() {
        return (
            <MiniPanel config={this.config} hideMenu typeForTest="no-channel">
                {allowedMiniPanel() ? null :
                    (<div className="bordered-content">
                        <div className="embedLoading">
                            <div>
                                <strong><FormattedMessage defaultMessage="No Screen Defined" id="screenSettings.noChannel.title"/></strong><br/>
                                <FormattedMessage defaultMessage="To start using {product} in {channelDefName} you have to create a screen." id="screenSettings.noChannel.description.1" values={{channelDefName: this.props.user.channelDef.name, product: config.PRODUCT_NAME}} />
                                <br/><br/><LoadingButton className="btn btn-primary" onClick={this.config}><span className="fa fa-cog" />{" "}<FormattedMessage defaultMessage="Create screen" id="screenSettings.noScreen.createScreen"/></LoadingButton>
                            </div>
                        </div>
                    </div>)
                }
            </MiniPanel>
        );
    }
}
export default Relay.createContainer(wrapNotFound(NoChannelPanel, (props) => {
    return props.user.channelDef;
}), {
    initialVariables: {
        channelDefId: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()},
                    organisations(first: 1) {
                        edges {
                            node {
                                id,
                                realId,
                                name
                            }
                        }
                    },
                    channelDef(id: $channelDefId) {
                        id,
                        realId,
                        name
                    }
                }
            `;
        }
    }
});
